import * as React from 'react';
import { DadosDesfazerRespostaQualidadeVidaTrabalho } from '../../modules/qualidadeVidaTrabalho';
import BarraRespostaQualidadeVidaTrabalho from './BarraRespostaQualidadeVidaTrabalho';
import { CardInclusaoPontoAssincronaRef } from './CardInclusaoPontoAssincrona';

interface Props {
  cardRef: React.RefObject<CardInclusaoPontoAssincronaRef | null>;
}

interface State {
  resposta: DadosDesfazerRespostaQualidadeVidaTrabalho | null;
}

// Enquanto o aviso de sucesso está aberto, a barra é filha dele. Ao fechar, a barra
// passa a ser montada no nível da tela. O estado fica aqui para as telas não repetirem a ligação.
class BarraRespostaQualidadeVidaTrabalhoContainer extends React.Component<
  Props,
  State
> {
  state: State = {
    resposta: null
  };

  exibir = (resposta: DadosDesfazerRespostaQualidadeVidaTrabalho | null) => {
    this.setState({ resposta });
  };

  render() {
    const { resposta } = this.state;
    const { cardRef } = this.props;

    if (resposta === null) {
      return null;
    }

    return (
      <BarraRespostaQualidadeVidaTrabalho
        dados={resposta}
        onDesfazer={() => cardRef.current?.desfazerRespostaQvt()}
        onFechar={() => cardRef.current?.limparRespostaQvt()}
      />
    );
  }
}

export default BarraRespostaQualidadeVidaTrabalhoContainer;
